mutation CreateEntriConfig($domain: String!, $subdomain: String) {
    entriConfigCreate(domain: $domain, subdomain: $subdomain)
}
